import { createReducer, on } from '@ngrx/store';
import { initialCompleteState } from './complete_state';
import {
  hideExtraData,
  updateAll,
  updateMaxMonthlyOrders,
  updateName,
  updatePassword,
  updatePhone,
  updateWeakPassPopover,
  updateSaving
} from './complete_actions_creator';

export const completeReducer = createReducer(
  initialCompleteState,
  on(updateName, (state, action) => ({...state, displayName: action.displayName})),
  on(updatePassword, (state, action) => ({...state, newPassword: action.newPassword})),
  on(updateMaxMonthlyOrders, (state, action) => ({...state, maxMonthlyOrders: action.maxMonthlyOrders})),
  on(updatePhone, (state, action) => ({...state, phone: action.phone})),
  on(updateAll, (state, action) => ({...state, ...action.payload})),
  on(hideExtraData, (state, action) => ({...state, hideExtraData: action.hideExtraData})),
  on(updateWeakPassPopover, (state, action) => ({...state, weakPassPopover: action.weakPassPopover})),
  on(updateSaving, (state, action) => ({...state, saving: action.saving})),
);
